import { useEffect, useRef, useState } from 'react';

const useInView = (options?: IntersectionObserverInit) => {
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [wasOnceVisible, setWasOnceVisible] = useState<boolean>(false);
    // @ts-ignore
    const ref = useRef<HTMLDivElement>();

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(entry.isIntersecting);

            if (isVisible && !entry.isIntersecting) {
                setWasOnceVisible(true);
            }
        }, options);

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, [options]);

    return {
        isVisible,
        wasOnceVisible,
        ref
    };
};

export default useInView;
